import React from "react";
import { Editor as CraftJsEditor } from "@craftjs/core";
import {
  TextWidget,
  ContainerWidget,
  ImageWidget,
  VideoWidget,
  DividerWidget,
  EmptyContainerWidget,
  Buttons,
  LinkWheelWidget,
  ImageGridWidget,
  SocialLinksWidget,
  DocumentWidget,
  AudioWidget
} from "../../components/SegmentBuilder/CodeBlocks";

import Accordion from "../../components/SegmentBuilder/CodeBlocks/Accordian";
import EmptyAccordionContainer from "../../components/SegmentBuilder/CodeBlocks/Accordian/EmptyAccordionContainer";
import { ImageWithText } from "../../components/SegmentBuilder/CodeBlocks/ImageWithText";
import AccordionContainer from "../../components/SegmentBuilder/CodeBlocks/Accordian/AccordianContainer";

function Editor({ children, onNodesChange = () => {}, nodes,...rest }) {
  return (
    <CraftJsEditor
      onNodesChange={onNodesChange}
      resolver={{
        TextWidget,
        ContainerWidget,
        ImageWidget,
        DocumentWidget,
        VideoWidget,
        DividerWidget,
        EmptyContainerWidget,
        Accordion,
        EmptyAccordionContainer,
        ImageWithText,
        AccordionContainer,
        LinkWheelWidget,
        Buttons,
        ImageGridWidget,
        SocialLinksWidget,
        AudioWidget
      }}
      {...rest}
    >

      {children}

    </CraftJsEditor>
  );
}

export default Editor;
